import React from "react";
import Personal from "./info/Personal";
import Communications from "./info/Communications";
import Address from "./info/Address";
import SystemInfo from "./info/SystemInfo";
import { Space } from "antd";

const ContactDetails = (props) => {
  const { record } = props;
  return (
    <div className="component">
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        <Personal record={record} />
        <Communications record={record} />
        <Address record={record} />
        <SystemInfo record={record} />
      </Space>
    </div>
  );
};
export default ContactDetails;
